<template>
  <div class="my-account bg-grey h-100">
    <NavbarMain />
    <div class="row mx-1 mx-md-5 my-3 h-auto">
      <NavbarAccount class="col-xl-auto col-md-12 h-100" />
      <div class="col-xl col-md-12 px-2 p-0">
        <div class="bg-white p-1 p-md-5 shadow-sm container-xl">
          <h4 class="mb-5">Mis notificaciones</h4>
          <div class="px-0 mx-0 px-md-5 mx-md-5">
            <div
              class="list-group-item cursor-pointer text-dark text-left"
              v-for="notification in notifications"
              :key="notification._id"
              :class="notification.active ? 'bg-notification-active' : ''"
              @click="viewNotification(notification)"
            >
              <div
                class="d-flex justify-content-between"
                v-if="notification.kind == 'SALE'"
              >
                <span
                  class="material-icons mr-2"
                  :class="notification.active ? 'text-success' : ''"
                  >add_business</span
                >
                <span class="text-left pr-2">
                  Tienes una nueva
                  <b>venta</b>!, ver resumen de compra
                </span>
              </div>
              <div
                class="d-flex justify-content-between"
                v-if="notification.kind == 'PRODUCT'"
              >
                <span
                  class="material-icons mr-2"
                  :class="notification.active ? 'text-success' : ''"
                  >local_offer</span
                >
                <span class="text-left pr-2">
                  {{ notification.message }}
                </span>
              </div>
                            <div
                class="d-flex justify-content-between"
                v-if="notification.kind == 'BUY'"
              >
                <span
                  class="material-icons mr-2"
                  :class="notification.active ? 'text-success' : ''"
                  >inventory</span
                >
                <span class="text-left pr-2">
                  {{ notification.message }}
                </span>
              </div>
              <p class="text-right mb-0 text-secondary pr-2">
                {{ strToDateString(notification.creationDate) }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import NavbarMain from "@/components/NavbarMain.vue";
import NavbarAccount from "@/components/account/NavbarAccount.vue";
import Api2 from "@/tools/Api2";
export default {
  name: "MyProfile",
  components: {
    NavbarMain,
    NavbarAccount,
  },
  data() {
    return {
      notifications: [],
      user: {
        creationDate: "",
        email: "",
      },
    };
  },
  computed: {
    ...mapState(["auth"]),
  },
  methods: {
        strToDateString(str) {
      let date = new Date(str);
      return `${date.getDate()}.${
        (date.getMonth() < 10 ? "0" : "") + date.getMonth()
      }.${date.getFullYear()} a las ${date.getHours()}:${date.getMinutes()}`;
    },
    viewNotification(notification) {
        switch (notification.kind) {
          case "BUY":
            this.$router.push(`/mi-compra/${notification.props.sale}`);
            break;
          case "SALE":
            this.$router.push(`/mi-venta/${notification.props.sale}`);
            break;
          case "PRODUCT":
            if (notification.props.state == 1) {
              this.$router.push(
                `/producto/${notification.props.product}/${notification.props.name}`
              );
            } else {
              this.$router.push(
                `/seller/publication/${notification.props.product}/${notification.props.name}`
              );
            }

            break;
          default:
            break;
        }
    },
  },
  created: async function () {
      Api2("notification")
        .get()
        .then((res) => {
          this.notifications = res.notifications.slice(0, 40);
        });
    
  },
};
</script>

<style lang="scss" scoped>
footer {
  position: absolute;
}

.text-secondary a {
  color: #172b46 !important;
  font-weight: bold;
}
</style>
